import Vue from 'vue';
import RzAuth from '@razlet/auth';
import { Capacitor } from '@capacitor/core';

export default function ({ store, $config: { jwtUrl } }) {
  Vue.use(RzAuth, { store, api: jwtUrl, app: Capacitor.isNativePlatform() });
}